export const NEW_SONG = "NEW_SONG";
export const MAX_RANGE = "MAX_RANGE";
export const RANGE = "RANGE";
export const PLAY = "PLAY";
export const LOADED = "LOADED";
export const ONCHANGE_LOADED = "ONCHANGE_LOADED";
export const VOLUME = "VOLUME";
export const CURRENT_SONG_INDEX = "CURRENT_SONG_INDEX";
export const CURRENT_SONG_LIST = "CURRENT_SONG_LIST";
